import styled from 'styled-components'

export const AccountDetailsCard = styled.div`
    display: grid;
    grid-template-rows: min-content 1fr;
    border: 1px solid var(--accent);
    font-size: var(--font-size-small);
`
